import { getImageInfo } from '@max/meituan-uni-image';
export function getImgWidthHeightR(img_url) {
    return new Promise((resolve, reject) => {
        getImageInfo({
            src: img_url
        }).then((img) => {
            const ratio = img.width / img.height;
            resolve({
                ratio: ratio,
                width: img.width,
                height: img.height
            });
        }).catch((err) => {
            console.log('获取图片信息失败', err);
        });
    });
}
